// Build v2 - Billionaire badge fix
import { render } from 'preact';
import { AppShell } from './app/AppShell';
import { ErrorBoundary } from './app/ErrorBoundary';
import { bootOnce } from './bootstrap';
import { ensureRuntimeConfigLoaded } from './bootstrap/config';
import './styles/index.css';

async function main() {
  await ensureRuntimeConfigLoaded();
  bootOnce();
  render(
    <ErrorBoundary>
      <AppShell />
    </ErrorBoundary>,
    document.getElementById('app')!,
  );
}

void main();

